import Checkbox from 'components/ui/Checkbox/Checkbox';
import SelectCustom from 'components/ui/SelectCustom/SelectCustom';
import { FC, Fragment } from 'react';
import { BoundOptions } from 'ts/dynamic/classes/BookOptionsCatalogue';
import { Pax } from 'ts/dynamic/interfaces/DynamicBookResponse';

interface OptionalServiceProps {
  pax: Pax;
  bagMeal: BoundOptions;
  flightSource: string;
  onChangeField: (param1: Pax, index: number) => void;
  paxIndex: number;
  key1: string;
}

const OptionalService: FC<OptionalServiceProps> = ({ pax, bagMeal, ...props }) => {
  return (
    <Fragment>
      {bagMeal.visible && bagMeal.paxTypes.includes(pax.paxTypeCode) && (
        <Fragment>
          {props.flightSource === 'ALP24F' ? (
            <div className="col-12 text-lh mb-10">
              <div className="mb-5">
                <span>{bagMeal.labelType}: </span>
                <span className="text-bold">{bagMeal.label}</span>
              </div>
              {bagMeal.options.map((cat, indexCat) => (
                <div key={indexCat} className="mb-5">
                  <Checkbox
                    label={cat.label}
                    onChange={() => {
                      let newVal: any[] = [...((pax as any)[props.key1 + 'Arr'] || [])];
                      if (newVal.includes(cat.value)) {
                        newVal = newVal.filter((bag) => bag !== cat.value);
                      } else {
                        newVal.push(cat.value);
                      }

                      const newPax = {
                        ...pax,
                        [props.key1 + 'Arr']: newVal,
                      };

                      props.onChangeField(newPax, props.paxIndex);
                    }}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="col-md-6 col-12 mb-10">
              <div className="mb-5">
                <span>{bagMeal.labelType}: </span>
                <span className="text-bold">{bagMeal.label}</span>
              </div>
              <SelectCustom
                options={bagMeal.options}
                value={(pax as any)[props.key1 + 'Arr']}
                onChange={(value) => {
                  const newPax = {
                    ...pax,
                    [props.key1 + 'Arr']: value,
                  };
                  props.onChangeField(newPax, props.paxIndex);
                }}
                isMulti={true}
              />
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default OptionalService;
